<template>
  <main id="app" class="app__body" :class="$route.name">
    <app-header v-if="this.$route.name !== 'view-video'" />
    <keep-alive :include="'register'">
      <router-view></router-view>
    </keep-alive>
    <app-footer/>
  </main>
</template>

<style lang="sass" rel="stylesheet/scss">
  @import '~imperavi-kube/dist/css/kube.css';
  @import '~uppy/dist/uppy.min.css';
  @import 'css/main.scss';
</style>

<script>
import AppHeader from '@/components/AppHeader';
import AppFooter from '@/components/AppFooter';
import Site from '@/store/index';
import router from './router';

export default {
  name: 'app',
  router,
  store: Site,
  components: {
    AppHeader,
    AppFooter,
  },
};
</script>

<style lang="scss">
.app__body {
  background-image: linear-gradient(to bottom, rgba(0,0,0,0) 0%,rgba(0,0,0,0) 80%,rgba(0,0,0,1) 100%), url('assets/farage_1.png');
  background-size: 100% auto;
  background-repeat: no-repeat;
  background-position: top;
  min-height: 100vh;
  display: flex;
  flex-direction: column;

  .app__content {
    flex: 1;
  }

  &.view-password-reset {
    background-size: cover;
    background-image: linear-gradient(to bottom, rgba(0,0,0,0) 0%,rgba(0,0,0,0) 80%,rgba(0,0,0,1) 100%), url('assets/farage_3.png');
  }
  &.view-video {
    background-image: none;
  }
}
</style>



// WEBPACK FOOTER //
// App.vue?a94256c4